/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux';
import { SelectPicker } from 'rsuite';
import { useEffect, useState } from 'react';
import { BaseModal } from '../BaseModal';
import { modalActions } from '@/Actions';
import { ListTable } from '@/Components/ListTable';
import { Input } from '@/Components/ui/input';

const dummyData = [
	{
		id: 23888,
		name: 'SF.RAVA KESARI (SWEET)_FILLING',
		skuCode: 'UYA2B139',
		categoryName: 'SFG',
		subCategory: 'Sweet',
		orderedQuantity: 10,
		fulfilled: 10,
		dispatched: 10,
		received: 10,
	},
	{
		id: 23890,
		name: 'IDIYAPPAM_FILLING',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B140',
		categoryName: 'Dry',
		subCategory: 'Breakfast',
		orderedQuantity: 20,
		fulfilled: 20,
		dispatched: 20,
		received: 20,
	},
	{
		id: 23891,
		name: 'SF.RAVA KITCHADI_FILLING',
		categoryName: 'SF.KITCHADI VARIETY',
		subCategory: 'SF.KITCHADI VARIETY',
		orderedQuantity: 30,
		fulfilled: 30,
		dispatched: 30,
		received: 30,
	},
	{
		id: 23893,
		name: 'Aloo Roti (SFG)',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B141',
		categoryName: 'SFG',
		subCategory: 'SFG',
		orderedQuantity: 40,
		fulfilled: 40,
		dispatched: 40,
		received: 40,
	},
	{
		id: 23894,
		name: 'SF Plain Roti (SFG)',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B142',
		categoryName: 'SFG',
		subCategory: 'SFG',
		orderedQuantity: 50,
		fulfilled: 50,
		dispatched: 50,
		received: 50,
	},
	{
		id: 23902,
		name: 'SF.GHEE PONGAL_DRY',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B143',
		categoryName: 'Dry',
		subCategory: 'Breakfast',
		orderedQuantity: 60,
		fulfilled: 60,
		dispatched: 60,
		received: 60,
	},
	{
		id: 23903,
		name: 'SF.GHEE PONGAL',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B144',
		categoryName: 'SFG',
		subCategory: 'SFG',
		orderedQuantity: 70,
		fulfilled: 70,
		dispatched: 70,
		received: 70,
	},
	{
		id: 23904,
		name: 'SF.RAVA KITCHADI',
		inventoryUnit: 'gram',
		purchaseUnit: '-',
		brand: 'a2b',
		skuCode: 'UYA2B145',
		categoryName: 'SF.KITCHADI VARIETY',
		subCategory: 'SF.KITCHADI VARIETY',
		orderedQuantity: 80,
		fulfilled: 25,
		dispatched: 25,
		received: 0,
	},
];

function OutletModal() {
	const modalData = useSelector((state) => state.modal.outletModal);
	const dispatch = useDispatch();
	const { show, data } = modalData ?? {};
	const [outlet, setOutlet] = useState(null);
	const [search, setSearch] = useState('');

	useEffect(() => {
		if (data?.selectedStore) {
			setOutlet(data?.selectedStore);
		}
	}, [data]);

	const colMap = {
		'UY Variant Id': 'id',
		'Product Name': 'name',
		'Category Name': 'categoryName',
		'Sub Category': 'subCategory',
		'SKU Code': 'skuCode',
		'Ordered Quantity': 'orderedQuantity',
		Fulfilled: 'fulfilled',
		Dispatched: 'dispatched',
		Received: 'received',
	};

	const SPECIAL_COLUMNS = [
		{
			title: 'UY Variant Id',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Product Name',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Sub Category',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'SKU Code',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Ordered Quantity',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Fulfilled',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Dispatched',
			config: {
				type: 'DATA',
			},
		},
		{
			title: 'Received',
			config: {
				type: 'DATA',
			},
		},
	];

	const SPECIAL_ITEMS = {
		'UY Variant Id': (id, value) => {
			return <div className='text-[12px] text-left'>{value}</div>;
		},
		'Product Name': (name, value) => {
			return <div className='text-[12px] text-left'>{value}</div>;
		},
		'Sub Category': (subCategory, value) => {
			return <div className='text-[12px] text-left'>{value}</div>;
		},
		'SKU Code': (skuCode, value) => {
			return <div className='text-[12px] text-left'>{value}</div>;
		},
		'Ordered Quantity': (orderedQuantity, value) => {
			return (
				<div className='text-[12px] text-left'>
					{value}
					{' '}
					kg
				</div>
			);
		},
		Fulfilled: (fulfilled, value) => {
			return (
				<div className='text-[12px] text-left'>
					{value}
					{' '}
					kg
				</div>
			);
		},
		Dispatched: (dispatched, value) => {
			return (
				<div className='text-[12px] text-left'>
					{value}
					{' '}
					kg
				</div>
			);
		},
		Received: (received, value) => {
			return (
				<div className='text-[12px] text-left'>
					{value}
					{' '}
					kg
				</div>
			);
		},
	};
	const handleClose = () => {
		dispatch(modalActions.toggleOutletModal(false));
	};

	const handleSearch = (value) => {
		setSearch(value);
	};
	const getFilteredData = () => {
		let filteredData = dummyData;

		// Filter by search
		if (search.length > 0) {
			const searchLower = search.toLowerCase();
			filteredData = filteredData.filter((item) => {
				const name = item.name ? item.name.toLowerCase() : '';
				const skuCode = item.skuCode ? item.skuCode.toLowerCase() : '';
				const categoryName = item.categoryName ? item.categoryName.toLowerCase() : '';
				const subCategory = item.subCategory ? item.subCategory.toLowerCase() : '';
				return (
					name.includes(searchLower) ||
					skuCode.includes(searchLower) ||
					categoryName.includes(searchLower) ||
					subCategory.includes(searchLower)
				);
			});
		}
		return filteredData;
	};

	return (
		<BaseModal
			heading='Outlet Details'
			open={show}
			handleClose={handleClose}
			renderBtns={() => {}}
			width='55rem'
			height='40rem'
		>
			<Input
				placeholder='Search'
				className='w-full'
				value={search}
				onChange={(e) => handleSearch(e.target.value)}
			/>
			{/* <SelectPicker
				data={data?.retailStoreList}
				placeholder='Select Outlet'
				className='w-[300px] flex justify-start'
				value={outlet}
				onChange={(value) => setOutlet(value)}
			/> */}
			<ListTable
				data={getFilteredData()}
				colMap={colMap}
				actions={SPECIAL_COLUMNS}
				special={SPECIAL_ITEMS}
			/>
		</BaseModal>
	);
}

export default OutletModal;
